export const EMAIL_REG_EXP = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
export const PHONE_REG_EXP = /^\+\d{10,15}$/;
export const PHONE_MAX_LENGTH = 15;

export const COMPANY_MAX_LENGTH = 100;
export const COMPANY_MIN_LENGTH = 2;
export const COMPANY_VALID_CHARS_REGEX = /^[A-Za-z0-9\s&.,'\/+-]*$/;
